import { logger } from '@/helpers/logger';
import { query } from './query';

export const themeKey = 'Theme';

export type Theme = 'DARK' | 'LIGHT';

const SGBS_VERSION = import.meta.env.VITE_SGBS_VERSION;

const SGBS_CDN_URL = `https://sgwt-cdn-sgbs.sgmarkets.com/sg-bootstrap/${SGBS_VERSION}/`;

// FIXME: use the same urls as index.html
const variableSgbsUrls = (theme: string | null) => {
  const variation = theme === 'DARK' ? 'dark' : 'standard';

  return {
    sgbs: `${SGBS_CDN_URL}core/css/sg-bootstrap-${variation}.min.css`,
    aggrid: `${SGBS_CDN_URL}ag-grid-theme/27-${variation}.min.css`,
  };
};

const updateThemeUrls = (theme: 'DARK' | 'LIGHT') => {
  for (const [id, url] of Object.entries(variableSgbsUrls(theme))) {
    const linkElement = document.querySelector<HTMLLinkElement>(`link[id="${id}"]`);
    const newLinkElement = document.createElement('link');

    newLinkElement.rel = 'stylesheet';
    newLinkElement.id = id;
    newLinkElement.href = url;

    if (linkElement !== null) {
      newLinkElement.onload = () => {
        document.head.removeChild(linkElement);
      };
    }

    document.head.appendChild(newLinkElement);
  }
};

export function setTheme(theme: Theme) {
  updateThemeUrls(theme);

  logger.logInformation('User switched to theme {theme}', theme);

  if (localStorage) {
    try {
      localStorage.setItem(themeKey, theme);
    } catch {
      console.error('Unable to store theme, localStorage might be full');
    }
  }
}

export function getTheme(): Theme {
  const savedTheme = typeof localStorage !== 'undefined' ? localStorage.getItem(themeKey) : 'LIGHT';

  const useDark =
    (savedTheme && savedTheme.toUpperCase() === 'DARK') ||
    (query.has('theme') && query.get('theme')?.toString().toUpperCase() === 'DARK');

  return useDark ? 'DARK' : 'LIGHT';
}
